module.exports = __webpack_public_path__ + "img/hero-poster_en.9649c4e.jpg";